<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png" />
    <p>{{ $t("message") }}</p>
    <div>
      <ValidationObserver v-slot="{ invalid }" ref="form">
        <validation-provider rules="required|email" v-slot="{ errors }">
          <input v-model="value" name="name" type="text" />
          <span>{{ errors[0] }}</span>
        </validation-provider>
        <button type="submit" :disabled="invalid">Submit</button>
      </ValidationObserver>
    </div>
    <div>
      <button v-on:click="showToast">Show toast</button>
      <button v-on:click="startLoading">Start Loading</button>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  name: "Home",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data: () => ({
    value: ""
  }),
  watch: {
    localeChange: function() {
      this.$refs.form.validate();
    }
  },
  computed: {
    localeChange() {
      return this.$i18n.locale;
    }
  },
  methods: {
    showToast() {
      this.$root.showToast("test", "test");
    },
    startLoading() {
      this.$root.$loading.start();
    }
  }
};
</script>
